import * as ambassadorWixEcomV1GiftCard from './ecom-v1-gift-card-gift-vouchers.http.js';
import * as ambassadorWixEcomV1GiftCardTypes from './ecom-v1-gift-card-gift-vouchers.types.js';
import * as ambassadorWixEcomV1GiftCardUniversalTypes from './ecom-v1-gift-card-gift-vouchers.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getGiftCard(): __PublicMethodMetaInfo<
  'POST',
  { code: string },
  ambassadorWixEcomV1GiftCardUniversalTypes.GetGiftCardRequest,
  ambassadorWixEcomV1GiftCardTypes.GetGiftCardRequest,
  ambassadorWixEcomV1GiftCardUniversalTypes.GetGiftCardResponse &
    ambassadorWixEcomV1GiftCardUniversalTypes.GetGiftCardResponseNonNullableFields,
  ambassadorWixEcomV1GiftCardTypes.GetGiftCardResponse &
    ambassadorWixEcomV1GiftCardTypes.GetGiftCardResponseNonNullableFields
> {
  const payload = { code: ':code' } as any;

  const getRequestOptions = ambassadorWixEcomV1GiftCard.getGiftCard(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/gift-cards/{code}',
    pathParams: { code: 'code' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function redeemGiftCard(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1GiftCardUniversalTypes.RedeemGiftCardRequest,
  ambassadorWixEcomV1GiftCardTypes.RedeemGiftCardRequest,
  ambassadorWixEcomV1GiftCardUniversalTypes.RedeemGiftCardResponse &
    ambassadorWixEcomV1GiftCardUniversalTypes.RedeemGiftCardResponseNonNullableFields,
  ambassadorWixEcomV1GiftCardTypes.RedeemGiftCardResponse &
    ambassadorWixEcomV1GiftCardTypes.RedeemGiftCardResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1GiftCard.redeemGiftCard(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/gift-cards/redeem',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function voidTransaction(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1GiftCardUniversalTypes.VoidTransactionRequest,
  ambassadorWixEcomV1GiftCardTypes.VoidTransactionRequest,
  ambassadorWixEcomV1GiftCardUniversalTypes.VoidTransactionResponse,
  ambassadorWixEcomV1GiftCardTypes.VoidTransactionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1GiftCard.voidTransaction(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/gift-cards/void',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
